import styled from "styled-components";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  COLORS,
  SIZE,
  MARGIN,
  DEVICE_TYPE,
  FONT_FAMILY,
} from "constants/variables";

export const PersonnelCarouselContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const PersonnelCardItem = styled.div`
  cursor: pointer;
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: ${MARGIN.fix24};
  padding: 0 ${SIZE.max400};
  @media (max-width: ${DEVICE_TYPE.fullHd}) {
    padding: 0 ${SIZE.max220};
  }
  @media (max-width: ${DEVICE_TYPE.largeDesktop}) {
    padding: 0 ${SIZE.max120};
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding: 0 ${SIZE.max80};
  }
`;

export const SeeMoreButton = styled.a`
  margin-top: ${SIZE.max32};
  padding: ${SIZE.max24};
  color: #0056b3;
  font-size: ${SIZE.max18};
  font-weight: 600;
  font-family: ${FONT_FAMILY.poppins};
  border: none;
  cursor: pointer;
  &:hover {
    color: ${COLORS.RaisinBlack};
  }
`;

export const SeeLessButton = styled.a`
  margin-top: ${SIZE.max32};
  padding: ${SIZE.max24};
  color: #0056b3;
  font-size: ${SIZE.max18};
  font-weight: 600;
  font-family: ${FONT_FAMILY.poppins};
  border: none;
  cursor: pointer;
  &:hover {
    color: ${COLORS.RaisinBlack};
  }
`;
